import script from "./AdminMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMessages.vue?vue&type=script&setup=true&lang=js"

import "./AdminMessages.vue?vue&type=style&index=0&id=d54a5268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d54a5268"]])

export default __exports__